var Acr = Acr || {};

Acr.MultiFeatures = function () {
  var Utility = window.Utility || {};
  var DeepLink;

  var $element;
  var $slider;
  var $slides;
  var $tabs;
  var $featuresContainer;
  var $featuresHeading;
  var $leftArrowSvg;
  var $rightArrowSvg;

  var debounceResize;
  var api;
  var defaultTab = 0;
  var leftArrowHtml;
  var rightArrowHtml;

  const slider = '.acr-multi-features-slick';
  const slides = '.acr-mlp-slide';
  const tabs = '.acr-mlp-tab';
  const featuresContainer = '.acr-mlp-features-container';
  const featuresHeading = '.acr-mlp-features-heading';
  const activeClass = 'acr-mlp-active';
  const tabLink = '.js-tab-link';
  const leftArrowSvgClass = '.acr-icon.arrow-left-icon';
  const rightArrowSvgClass = '.acr-icon.arrow-right-icon';


  function slickAfterChange(e, slick, currentSlide) {
    const hash = location.hash.replace('#', '');
    if (hash && !isCurrentSlideHash(hash, currentSlide)) {
      history.pushState('', document.title, window.location.pathname);
    }

    if ($(slick.$slides[currentSlide]).hasClass('acr-mlp-all-features')) {
      // reinit scrollPane if slide is all features
      resize();
    }
  }

  function slickBeforeChange(e, slick, currentSlide, nextSlide) {
    var $dots = $element.find('.slick-dots');
    $tabs.removeClass(activeClass);
    $tabs.eq(nextSlide).addClass(activeClass);

    if ($(slick.$slides[nextSlide]).hasClass('acr-mlp-all-features')) {
      $dots.hide();
    } else {
      $dots.show();
    }
  }

  function setSlick() {
    $slider.slick({
      arrows: false,
      useTransform: true,
      infinite: false,
      centerPadding: '10px',
      initialSlide: defaultTab,
      responsive: [{
        breakpoint: 1024,
        settings: {
          arrows: true,
          dots: true,
          infinite: true,
          centerPadding: '0px',
          prevArrow: '<button type="button" data-role="none" '
            + 'class="slick-prev" aria-label="Previous" '
            + 'tabindex="0" role="button">'
            + leftArrowHtml
            + '</button>',
          nextArrow: '<button type="button" data-role="none" '
            + 'class="slick-next" aria-label="Next" '
            + 'tabindex="0" role="button">'
            + rightArrowHtml
            + '</button>',
        },
      }],
    });

    $slider.on('afterChange', slickAfterChange);

    $slider.on('beforeChange', slickBeforeChange);
  }

  function changeSlide(e) {
    if (location.hash) {
      history.pushState('', document.title, window.location.pathname);
    }

    var currentTarget = $(e.target).closest(tabLink);
    var position = $tabs.index(currentTarget);
    $slider.slick('slickGoTo', position);
  }

  function selectTab(selectedTab, setSlick) {
    var position = $tabs.index(selectedTab);
    $tabs.removeClass(activeClass);
    $(selectedTab).addClass(activeClass);

    if (setSlick) {
      $slider.slick('slickGoTo', position, true);
    }
  }

  function maxHeightMobileCalculation() {
    if (window.innerWidth < Constants.breakpoints.md) {
      var maxHeight = 0;
      $slides.each(function (index, slide) {
        var slideHeight = $(slide).find('.acr-mlp-bg').outerHeight() + $(slide).find('.acr-mlp-content').outerHeight();
        maxHeight = slideHeight > maxHeight ? slideHeight : maxHeight;
      });
      $element.find(slides).height(maxHeight);
    } else {
      $element.find(slides).height('auto');
    }

    setFeaturesHeight();
  }

  function setFeaturesHeight() {
    const heightParent = $slides.innerHeight();
    const heightSibling = $featuresHeading.outerHeight();

    $featuresContainer.height(heightParent - heightSibling);
  }

  function getTabSettings() {
    defaultTab = parseInt($element.data('defaultTab'), 10) - 1;
    if (defaultTab) {
      var selectedTab = $tabs[defaultTab];
      selectTab(selectedTab, false);
    } else {
      defaultTab = 0;
    }
  }

  function resize() {
    maxHeightMobileCalculation();

    if (api) {
      api.reinitialise();
    }
  }

  function resizeCallback() {
    clearTimeout(debounceResize);

    debounceResize = setTimeout(resize, 250);
  }

  function imagesReady() {
    resize();
  }

  function deepLinking() {
    if ($element.length) {
      var hashTab = DeepLink.getTabIdHashElement($element[0]);
      if (hashTab) {
        selectTab($(hashTab), true);
      }
    }
  }

  function isCurrentSlideHash(hash, currentIndex) {
    var isSlideIndex = false;
    if ($element.length) {
      const hashSelector = !Utility.isIE11() ? '.js-tab-link[tab-id="' + hash + '" i]' : '.js-tab-link[tab-id="' + hash + '"]';
      const tabHash = $element[0].querySelector(hashSelector);
      if (tabHash) {
        const tabHashIndex = $tabs.index(tabHash);
        isSlideIndex = tabHashIndex === currentIndex;
      }
    }
    return isSlideIndex;
  }

  function bindEvents() {
    $tabs.on('click', changeSlide);
    $(window).on('resize', resizeCallback);
    $(window).on('load', deepLinking);
    $(window).on('hashchange', deepLinking);
  }

  function getSvgsHTML() {
    if ($leftArrowSvg.length > 0) {
      Utility.removeClassFromSvg($leftArrowSvg, 'hide');
      leftArrowHtml = $leftArrowSvg[0].outerHTML;
      $leftArrowSvg[0].parentNode.removeChild($leftArrowSvg[0]);
    }
    if ($rightArrowSvg.length > 0) {
      Utility.removeClassFromSvg($rightArrowSvg, 'hide');
      rightArrowHtml = $rightArrowSvg[0].outerHTML;
      $rightArrowSvg[0].parentNode.removeChild($rightArrowSvg[0]);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $slider = $element.find(slider);
    $slides = $element.find(slides);
    $tabs = $element.find(tabs);
    $featuresContainer = $element.find(featuresContainer);
    $featuresHeading = $element.find(featuresHeading);
    $leftArrowSvg = $element.find(leftArrowSvgClass);
    $rightArrowSvg = $element.find(rightArrowSvgClass);
  }

  function init(element) {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};
    initSelectors(element);
    bindEvents();
    getTabSettings();
    getSvgsHTML();
    setSlick();
    maxHeightMobileCalculation();

    Utility.imagesReady($slider, imagesReady);
  }

  return {
    init: init,
  };
};
